import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useCustomerAuth } from '../../context/CustomerAuthContext';
import './Auth.css';

function safeCustomerReturnUrl(raw) {
  if (!raw || typeof raw !== 'string') return null;
  const u = raw.trim();
  if (!u.startsWith('/') || u.startsWith('//')) return null;
  if (!u.startsWith('/customer/')) return null;
  return u;
}

const CustomerCodeSignup = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnParam = searchParams.get('return');
  const returnTo = useMemo(
    () => safeCustomerReturnUrl(returnParam) || '/customer/profile',
    [returnParam]
  );
  const { signupWithCode, isAuthenticated } = useCustomerAuth();

  useEffect(() => {
    if (isAuthenticated) navigate(returnTo);
  }, [isAuthenticated, navigate, returnTo]);

  const [code, setCode] = useState(searchParams.get('code') || '');
  const [firstName, setFirstName] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!code.trim() || !firstName.trim()) {
      setError('Enter your code and your name');
      return;
    }

    setIsLoading(true);
    try {
      await signupWithCode(code.trim(), firstName.trim());
      navigate(returnTo);
    } catch (err) {
      setError(err.message || 'That code did not work. Please check it and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>🔒 Join with your code</h1>
        <p className="auth-subtitle">Enter the code you were given and your name — no email or password needed</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Your Code</label>
            <input
              type="text"
              name="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              style={{ textTransform: 'uppercase' }}
              autoCapitalize="characters"
              autoCorrect="off"
              autoComplete="off"
              required
            />
          </div>

          <div className="form-group">
            <label>Your Name</label>
            <input
              type="text"
              name="firstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="auth-button" disabled={isLoading}>
            {isLoading ? 'Joining…' : 'Join'}
          </button>
        </form>

        <p className="auth-footer">
          Already have a full account?{' '}
          <Link to={returnParam ? `/customer/login?return=${encodeURIComponent(returnParam)}` : '/customer/login'}>
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default CustomerCodeSignup;
